"use client";
import useSWR from "swr";
import { useState } from "react";
import type { CashflowSummary, Currency } from "@/types";
import type { ProjectionScenario } from "@/constants/projectionScenarioSelect";
import { cfApi, cfFetcher } from "../api/apiClient";
import { useCurrentCurrency } from "./useCurrentCurrency";
import { useConsolidated } from "./useConsolidated";

export function useCashflow() {
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");
  const [projectionScenario, setProjectionScenario] =
    useState<ProjectionScenario>("mid");
  const { currency, setCurrency } = useCurrentCurrency();
  const { effectiveConsolidated } = useConsolidated();

  const params = new URLSearchParams();
  if (dateFrom) params.set("dateFrom", dateFrom);
  if (dateTo) params.set("dateTo", dateTo);

  const swrKey = effectiveConsolidated
    ? (() => {
        params.set("displayCurrency", currency);
        return cfApi(`/cashflow/consolidated?${params.toString()}`);
      })()
    : (() => {
        params.set("currency", currency);
        return cfApi(`/cashflow?${params.toString()}`);
      })();

  const { data, error, isLoading } = useSWR<CashflowSummary>(swrKey, cfFetcher);

  return {
    summary: data,
    isLoading,
    error,
    effectiveConsolidated,
    dateFrom,
    dateTo,
    setDateFrom,
    setDateTo,
    currency: currency as Currency,
    setCurrency,
    projectionScenario,
    setProjectionScenario,
  };
}
